module.exports = __webpack_public_path__ + "static/media/kyunghyee_university.980ac674.png";